/**
 * What the sidebar names under a greyed-out "Publish campaign" (scene 5).
 *
 * The publish checklist has only four coarse items and the SALARY is not one of
 * them -- it is enforced by its own step at publish time -- so the sentence the
 * description fixes, "Still needed before publishing: salary", cannot be built
 * from the checklist alone and the salary is asked about separately.
 *
 * The other items are named in the words the SIDEBAR ITSELF uses for those
 * screens (data/menuGroups.tsx), so the line never names something the person
 * cannot find anywhere else.
 */
export const CHECKLIST_IN_WORDS: Record<string, string> = {
  targeting: 'Targeting',
  advertising: 'Advertising',
  vacancy_page: 'Vacancy Page',
  typeform: 'Application Form',
};

export interface StillNeededInput {
  checklist: { key: string; completed: boolean }[];
  /** Does this campaign have to carry a salary at all? */
  salaryRequired: boolean;
  /** Has it got one? */
  salaryFilledIn: boolean;
}

export const stillNeededBeforePublishing = ({
  checklist,
  salaryRequired,
  salaryFilledIn,
}: StillNeededInput): string[] => [
  ...(salaryRequired && !salaryFilledIn ? ['salary'] : []),
  ...checklist
    .filter(({ completed }) => !completed)
    .map(({ key }) => CHECKLIST_IN_WORDS[key] ?? key),
];
